import { lazy } from 'solid-js'
import { messages } from '../../pages/stays-page/stays-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/stays-page/stays-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    overflow: false,
    path: '/stays/:booking_id?',
    requiredMode: 'guest',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
